import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { categories } from "../data/mainData";
import { FaWhatsapp } from "react-icons/fa6";

const ProductDetail = () => {
  const { slug } = useParams();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const product = categories.find(
    (item) => item.slug.replace("/", "") === slug
  );

  const whatsappQuote = (product) => {
    const message = `Hello Celestial Grains,

I would like to request a quote for:

Product: ${product.name}

Please share pricing, MOQ, and availability.

Thank you.`;

    window.open(
      `https://wa.me/14034979816?text=${encodeURIComponent(message)}`,
      "_blank"
    );

  }

  if (!product) {
    return (
      <div style={{ textAlign: "center", padding: "100px 20px" }}>
        <h1>Product Not Found</h1>
      </div>
    );
  }

  return (
    <>
      {/* BREADCRUMB */}
      <section
        style={{
          padding: "120px 0 40px",
          background: "#2b2015", // CHANGE THIS
          borderBottom: "1px solid #e5dfd3",
        }}
      >
        <div className="container">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              flexWrap: "wrap",
              fontSize: "15px",
              color: "#ffffff",
            }}
          >
            <Link
              to="/"
              style={{
                textDecoration: "none",
                color: "#ffffff",
              }}
            >
              Home
            </Link>

            <span>/</span>

            <Link
              to="/products"
              style={{
                textDecoration: "none",
                color: "#ffffff",
              }}
            >
              Products
            </Link>

            <span>/</span>

            <span
              style={{
                color: "#c8a45a",
                fontWeight: "600",
              }}
            >
              {product.name}
            </span>
          </div>

          <h1
            style={{
              marginTop: "20px",
              fontSize: "48px",
              fontWeight: "700",
              color: "#c8a45a",
            }}
          >
            {product.name}
          </h1>
        </div>
      </section>

      {/* PRODUCT DETAIL SECTION */}
      <section className="section about product-detail">
        <div className="about__bg-text">{product.name}</div>

        <div className="container about__inner">
          {/* LEFT VISUAL */}
          <div style={{border: "4px solid var(--cream-dark)"}} className="about__visual">
            <img
              src={product.img}
              alt={product.name}
              className="about__img about__img--main"
            />

            {/* <img
              src={product.img}
              alt={product.name}
              className="about__img about__img--accent"
            /> */}

            <div className="about__badge">
              <span className="about__badge-num">{product.tag}</span>
              <span className="about__badge-sub">
                Premium Export Quality
              </span>
            </div>
          </div>

          {/* RIGHT CONTENT */}
          <div className="about__copy">
            <span className="section__label">
              Premium Canadian Pulses
            </span>

            <h2 className="section__title">
              {product.name}
              {/* <br />
              Global Export Excellence */}
            </h2>

            <p
              style={{
                fontSize: "18px",
                fontWeight: "500",
                color: "#d4a017",
              }}
            >
              {product.desc}
            </p>

            <p>{product.content}</p>

            {/* <p>
              Carefully sourced from trusted Canadian farms and processed under
              strict quality standards, our{" "}
              {product.name.toLowerCase()} are prepared for international
              markets with reliable supply, export-ready packaging, and complete
              documentation support.
            </p> */}

            <p>
              We ensure premium quality, consistent sizing, low impurities, and
              efficient logistics to serve importers, wholesalers, food
              manufacturers, and retailers worldwide.
            </p>

            {/* FEATURE PILLARS */}
            <div className="about__pillars">
              {[
                "High Protein",
                "Export Grade",
                "Premium Quality",
                "Global Supply",
              ].map((p) => (
                <div key={p} className="pillar">
                  <div className="pillar__dot" />
                  <span>{p}</span>
                </div>
              ))}
            </div>

            {/* CTA BUTTONS */}
            <div
              style={{
                display: "flex",
                gap: "16px",
                marginTop: "35px",
                flexWrap: "wrap",
              }}
            >
              <button
                onClick={() => whatsappQuote(product)}
                className="btn btn--gold"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                }}
              >
                <span>Request Quote</span>
                <FaWhatsapp size={20} />
              </button>

              {/* <button className="btn btn--outline">
                Download Brochure
              </button> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProductDetail;